import { Text, Button, Modal, ModalOverlay, ModalContent, ModalHeader, ModalCloseButton, ModalBody, ModalFooter, Stack } from "@chakra-ui/react";
import React, { useRef } from "react";
import { MdDeleteOutline } from "react-icons/md";
export function ConfirmDeleteModal({ isOpen = false, onClose = null, tag = null, deleteFn, isDeleting = false, authKey }) {
    const initialRef = useRef(null);

    return (
        <>
            <Modal isCentered scrollBehavior='inside' initialFocusRef={initialRef} closeOnOverlayClick={false} isOpen={isOpen} onClose={onClose}>
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader></ModalHeader>
                    <ModalCloseButton />
                    <ModalBody pb={6}>
                        <Stack spacing={5}>
                            <Stack spacing={1} align={'center'}>
                                <MdDeleteOutline size={40} color="#da4646" />
                                <Text fontSize={24} color='red.600'>Delete {tag ? tag[0].toUpperCase() + tag.slice(1, tag.length) : ''}?</Text>
                            </Stack>
                            <Stack spacing={1} align={'center'}>
                                <Text>Are you sure you want to delete this {tag}?</Text>
                                <Text>This action cannot be reversed.</Text>
                            </Stack>
                        </Stack>
                    </ModalBody>

                    <ModalFooter>
                        <Stack direction={'row'}>
                            <Button onClick={onClose}>No</Button>
                            <Button isLoading={isDeleting} onClick={() => deleteFn(authKey)} type="button" bgColor='red.500' color='white' _hover={{
                                bg: "red.300"
                            }} mr={3}>
                                Yes, Delete
                            </Button>
                        </Stack>
                    </ModalFooter>
                </ModalContent>
            </Modal>
        </>
    )
}